import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Button } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { CustomModal } from "../../../../components/CustomModal";
import ProfessionAndSkillModal from "../modal/ProfessionAndSkillModal";
import ProfessionsAndSkillsContext from "../../../../context/professionsAndSkillsContext";
import {
  cancelModifiedProfessionAndSkillUpdate,
  deleteProfessionsAndSkills,
  editProfessionsAndSkills,
  editRejectedProfessionAndSkill,
} from "../../../../service/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import FileKeysContext from "../../../../context/fileKeysContext";
import { uiHelper } from "../../../../helpers/uihelper";
import Swal from "sweetalert2";
import UploadingProcessContext from "../../../../context/uploadingProcessContext";

function ProfessionsAndSkillsSwiper({ professionAndSkill }) {
  let w = document.documentElement.clientWidth || window.innerWidth;
  const [modalSize, setModalSize] = useState("");
  const [loading,setLoading] = useState()

  useEffect(() => {
    if (w > 640) {
      setModalSize("52vw");
    }
    if (w <= 640) {
      setModalSize("100vw");
    }
  }, [w]);

  const [psData, setPsData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const queryCilent = useQueryClient();

  const { newOldKeys, resetFileKeysContext } = useContext(FileKeysContext);
  const { title, description, resetProfessionsAndSkillsContext } = useContext(
    ProfessionsAndSkillsContext
  );
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext);

  useEffect(() => {
    setPsData(uiHelper(professionAndSkill));
  }, [professionAndSkill]);

  const editMutation = useMutation(
    psData?.modifiedApi
      ? editRejectedProfessionAndSkill
      : editProfessionsAndSkills,
    {
      onError: () => {
        setOpenModal(true)
        setLoading(false)
      },
      onSuccess: () => {
        setOpenModal(false);
        setLoading(false)

        return queryCilent.invalidateQueries({
          queryKey: ["professionsAndSkills"],
        });
      },
      onMutate:()=>{
        setLoading(true)
      }
    }
  );

  const deleteMutation = useMutation(deleteProfessionsAndSkills, {
    onSuccess: () => {
      return queryCilent.invalidateQueries({
        queryKey: ["professionsAndSkills"],
      });
    },
  });

  const cancelUpdateMutation = useMutation(
    cancelModifiedProfessionAndSkillUpdate,
    {
      onSuccess: () => {
        return queryCilent.invalidateQueries({
          queryKey: ["professionsAndSkills"],
        });
      },
    }
  );

  const onModalOk = () => {
    editMutation.mutate({
      body: { title: title, description: description, files: newOldKeys },
      skillId: professionAndSkill?.id,
    });
  };

  const doEdit = () => {
    resetFileKeysContext();
    resetProfessionsAndSkillsContext();
    resetUploadingProcessContext();
    setOpenModal(true);
  };

  const cancelUpdate = () =>
    cancelUpdateMutation.mutate(professionAndSkill?.id);

  const deleteProAndSkill = () =>
    Swal.fire({
      title: "حذف محتوا",
      text: "در صورت تایید،این محتوا به طور کلی از صفحه شخصی شما حذف خواهد شد",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "تایید",
      cancelButtonText: "لغو",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteMutation.mutate(professionAndSkill?.id);
        Swal.fire({
          title: "حذف محتوا",
          text: "محتوای مورد نظر با موفقیت از صفحه شما حذف گردید",
          icon: "success",
          confirmButtonText: "متوجه شدم",
        });
      }
    });

  return (
    <div className="flex max-lg:flex-col relative py-[1.25rem] px-[1.5rem] bg-gray-50 w-full h-full justify-between flex-row-reverse max-lg:items-center max-lg:justify-evenly max-lg:p-[0.5rem] rounded-xl shadow-md">
      {/* slides */}
      <div className="flex flex-row h-[210px] w-[258px] max-lg:h-1/2 rounded-xl">
        <Swiper
          navigation={true}
          pagination={{
            clickable: true,
          }}
          dir="rtl"
          modules={[Pagination, Navigation]}
          slidesPerView={1}
          centeredSlides={false}
          style={{
            "--swiper-pagination-color": "#005AC8",
            "--swiper-pagination-bullet-inactive-color": "#fff",
            "--swiper-pagination-bullet-inactive-opacity": "1",
            "--swiper-pagination-bullet-size": "8px",
          }}
        >
          {" "}
          {psData?.data?.files.map((file, i) =>
            file.toLowerCase().endsWith("jpg") ||
            file.toLowerCase().endsWith("jpeg") ||
            file.toLowerCase().endsWith("png") ||
            file.toLowerCase().endsWith("jfif") ? (
              <SwiperSlide key={i}>
                <img
                  className="rounded-xl w-full h-full  "
                  alt="proto"
                  src={`${process.env.REACT_APP_ARVAN_S3_BASE_URL}${file}`}
                />
              </SwiperSlide>
            ) : (
              <SwiperSlide>
                <video
                  className="rounded-xl h-full w-full"
                  controls="true"
                  
                  src={`${process.env.REACT_APP_ARVAN_S3_BASE_URL}${file}`}
                />
              </SwiperSlide>
            )
          )}
        </Swiper>
      </div>

      {/* title, content, action buttons */}
      <div className="flex flex-col font-body max-lg:w-fit w-[217px]   max-lg:items-center  max-lg:gap-5 justify-between ">
        {/* title */}
        <h2 className="text-base  font-semibold text-black">
          {psData?.data?.title}
        </h2>

        {/* content */}
        <div className=" h-[6.5rem] overflow-y-scroll w-full overflow-x-hidden max-lg:text-ellipsis max-lg:text-xs max-lg:overflow-hidden  text-justify p-2 ">

        <p  >
          {psData?.data?.description}
        </p>
        </div>

        {psData?.showEditBtn && (
          <Button
            className="max-lg:w-1/2 z-40"
            icon={<EditOutlined />}
            onClick={doEdit}
          >
            ویرایش محتوا
          </Button>
        )}

        {/* action buttons */}
        <div className="absolute bottom-4 left-2 right-2 z-40">
          {/* cancel and edit */}
          <>
            {psData?.showCancelBtn && (
              <Button
                className="px-12 text-red-600 max-lg:m-auto :ml-auto"
                icon={<CloseOutlined />}
                onClick={cancelUpdate}
              >
                لغو بررسی
              </Button>
            )}
          </>
        </div>
        {/* delete */}
        {psData?.showDeleteBtn && (
          <div className="absolute top-0 left-0 z-50">
            <Button
              size="large"
              style={{
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              icon={<CloseOutlined style={{ color: "red" }} />}
              onClick={deleteProAndSkill}
            />
          </div>
        )}
      </div>

      {/* info texts */}
      {psData?.showMaskLayer && (
        <div className="flex w-full flex-col max-lg:justify-center justify-start py-10 gap-3 bg-slate-200/80 absolute top-0 left-0 bottom-0 font-body rounded-xl z-30">
          {/* main info */}
          <p className="text-lg font-bold text-black">{psData?.mainInfoText}</p>

          {/* detail info */}
          <p className="text-sm font-bold text-black">
            {psData?.detailInfoText}
          </p>
        </div>
      )}

      {openModal && (
        <CustomModal
        loading={loading}
          size={modalSize}
          visible={openModal}
          handleCancel={() => setOpenModal(false)}
          onOk={onModalOk}
        >
          <ProfessionAndSkillModal professionAndSkill={psData?.data} />
        </CustomModal>
      )}
    </div>
  );
}

export default ProfessionsAndSkillsSwiper;
